module.exports = __webpack_public_path__ + "img/image-095.cd681452.jpg";